export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入："])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["继续"])}
}